import * as React from "react";

const LoadingWidget = () => {
    return (
        <div className="row">
            <div className="col-12 text-center">
                <div className="lds-ellipsis">
                    <div />
                    <div />
                    <div />
                    <div />
                </div>
            </div>
        </div>
    );
};

export default LoadingWidget;



// WEBPACK FOOTER //
// ./src/components/common/LoadingWidget.tsx